import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { NavController } from '@ionic/angular';
import { JwtService } from 'src/infrastructure/adapters/services/jwt.service';

// Guard for protected routes - redirects to login if token is expired
export const authGuard: CanActivateFn = (route, state) => {
  const navCtrl = inject(NavController);
  const jwtService = inject(JwtService);
  
  if (jwtService.isTokenExpired()) {
    // Token is expired, redirect to login
    // Use navigateRoot to reset navigation stack
    navCtrl.navigateRoot('/login');
    return false;
  }
  
  return true;
};

// Guard for login routes - redirects to schedule if token is valid
export const loginGuard: CanActivateFn = (route, state) => {
  const navCtrl = inject(NavController);
  const jwtService = inject(JwtService);
  
  if (!jwtService.isTokenExpired()) {
    // Token is valid, redirect to schedule
    // Use navigateRoot to reset navigation stack
    navCtrl.navigateRoot('/schedule');
    return false;
  }
  
  return true;
};